import { NbToastrService } from '@nebular/theme';
import { Component, OnInit } from '@angular/core';
import { FramelinksService } from '../../apiclient';
import { ActivatedRoute } from '@angular/router';
import { UserSessionService } from '../../UserSession/user-session.service';
import {Location} from '@angular/common';
/**
 * Componente que renderiza el editor de framelinks
 */
@Component({
  selector: 'ngx-frame-link-editor',
  templateUrl: './frame-link-editor.component.html',
  styleUrls: ['./frame-link-editor.component.scss']
})
export class FrameLinkEditorComponent implements OnInit {

  framelinkdata: any = {}
  idcompany: string;
  idlink: string;
  loading: boolean = false;
  categoryOptions = ["Mapas","Informes","Clima","Menú"];

  constructor(private route: ActivatedRoute,
    private frmaeLinksService: FramelinksService,
    private userSessionService: UserSessionService,
    private nbToastrService: NbToastrService,
    private location: Location) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.idcompany = params.get('company');
      this.idlink = params.get('framelink');

      if(this.idlink != '0'){
      this.frmaeLinksService.getsingleframelink(+this.idcompany,+this.idlink,this.userSessionService.accessToken).subscribe((data) => {
        this.framelinkdata = data;
        if (this.framelinkdata.icon == undefined){
          this.framelinkdata.icon = {}
        }
      });
    }else{
      this.framelinkdata.icon = {}
    }
    })
  }

  /**
   * REgresa a la página anterior
   */
  back(): void{
    this.location.back()
  }

  /**
   * Guarda el framelink
   */
  guardar(): void{
    this.loading = true;
    if(this.idlink == '0'){
      this.frmaeLinksService.createframelink(+this.idcompany,this.framelinkdata,this.userSessionService.accessToken).subscribe((data) => {

        this.framelinkdata = data;
        this.loading = false;
        this.nbToastrService.success('Guardado con éxito','Guardar')
      });
    }else{
      this.frmaeLinksService.updateframelink(+this.idcompany,
        +this.idlink,this.framelinkdata,this.userSessionService.accessToken).subscribe((data) => {

        this.framelinkdata = data;
        this.loading = false;
        this.nbToastrService.success('Guardado con éxito','Guardar')
      })
    }
  }

}
